export const API_PROJECT_DESCRIPTION_METRICS_ID_TRANSLATIONS_FIELDS = [
    'project_first_type.results_impacts_section.metrics.project_description_metrics_id.translations.id',
    'project_first_type.results_impacts_section.metrics.project_description_metrics_id.translations.languages_code',
    'project_first_type.results_impacts_section.metrics.project_description_metrics_id.translations.title',
    'project_first_type.results_impacts_section.metrics.project_description_metrics_id.translations.unit'
];
